import React, {useState, useEffect} from "react";
import { useTranslation } from "react-i18next";
import { PDFViewer, Document, Page, Image, Text, View, StyleSheet, Font, Svg, Link } from "@react-pdf/renderer"
import LogoLAE from "../../../images/LogoLAE.png"
import LogoTSP from "../../../images/logo_tsp.png"
import extintores1 from "../../../images/extintores1.jpg"
import extintores2 from "../../../images/extintores2.jpg"
import bocaIncendio from "../../../images/bocaIncendio.png"
import cuartoContadores from "../../../images/cuartoContadores.png"
import estado from "../../../images/estado.png"
import { withRouter } from "../../../providers/withRouter";
import { getVisitSheet, getVisitSheetIdFromSale } from "../../../services";
import CircularProgress from '@mui/material/CircularProgress';
import RobotoRegular from "../../../fonts/Roboto-Regular.ttf"
import RobotoBold from "../../../fonts/Roboto-Bold.ttf"
import RobotoItalic from "../../../fonts/Roboto-Italic.ttf"
import RobotoBoldItalic from "../../../fonts/Roboto-BoldItalic.ttf"
import { formatoFechasEs } from "../../../functions/funciones";
import portada from '../../../images/PortadaEmergencia.png'
import { format } from 'date-fns';
import { getDateLocale } from '../../../i18n';
import PDFHandler from "../../../components/pdfs/PDFHandler";


Font.register({
    family: 'Roboto',
    fonts: [
      { src: RobotoItalic, fontWeight: 400 },
      { src: RobotoRegular, fontWeight: 400 },
      { src: RobotoBold, fontWeight: 700 },
      { src: RobotoBoldItalic, fontWeight: 800 },
    ]
});
const styles = StyleSheet.create({
    docTitle: {
        position: 'absolute',
        left: 100,
        right: 100,
        bottom: '100px',
        textAlign: 'center',
        fontSize: '16px',
        color: '#92004D',
        fontFamily: 'Roboto',
        fontWeight: 700,
        textTransform: 'uppercase'
    },
    docTitle2: {
        position: 'absolute',
        left: 70,
        right: 70,
        bottom: '60px',
        textAlign: 'center',
        fontSize: '16px',
        color: '#92004D',
        fontFamily: 'Roboto',
        fontWeight: 700,
        textTransform: 'uppercase'
    },
    body: {
        // paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: '2cm',
    },
    table: { 
        display: "table", 
        width: "auto", 
        borderStyle: "solid", 
        borderWidth: 1, 
        borderRightWidth: 0, 
        borderBottomWidth: 0 
    }, 
    tableRow: { 
        margin: "auto", 
        flexDirection: "row" 
    }, 
    tableColHeader: { 
        width: "33%", 
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        backgroundColor: '#375491',
        color: '#ffffff',
    }, 
    tableColHeader1: { 
        width: "34%", 
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        backgroundColor: '#375491',
        color: '#ffffff',
    }, 
    tableColHeaderProv: { 
        width: "33%", 
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        backgroundColor: '#ccc',
        color: '#000000',
    }, 
    tableColHeaderProv1: { 
        width: "34%", 
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        backgroundColor: '#ccc',
        color: '#000000',
    }, 
    tableColHeaderSOS: { 
        width: "50%",
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        backgroundColor:'#ccc',
        color: '#000000',
    }, 
    tableColHeaderNM: { 
        width: "100%", 
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        backgroundColor: '#ffffff',
        color: '#000000',
    }, 
    tableColHeaderExt: { 
        width: "9.09%",
        height:60,
        padding: 0,
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        backgroundColor:'#ccc',
        color: '#000000',
    }, 
    tableColHeaderExt1: { 
        width: "9.1%",
        height:60,
        padding: 0,
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        backgroundColor:'#ccc',
        color: '#000000',
    }, 
    tableColExt: { 
        width: "9.09%", 
        height:16,
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
    }, 
    tableCol1Ext: { 
        width: "9.1%", 
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
    }, 
    tableCellExt: { 
        margin: "auto", 
        marginTop: 5, 
        fontSize: 8 
    },
    tableCol: { 
        width: "33%", 
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
    }, 
    tableCol1: { 
        width: "34%", 
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
    }, 
    tableColSOS: { 
        width: "50%",
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        color:'red',
    }, 
    tableColNM: { 
        width: "100%", 
        borderStyle: "solid", 
        borderWidth: 1, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
    }, 
    tableCell: { 
        margin: "auto", 
        marginTop: 5, 
        marginBottom: 5, 
        fontSize: 8 
    },
    pdfHeader: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        position: 'fixed',
        top: 0,
        backgroundColor: '#ffffff',
        /* margin:'2cm', */
    },
    pdfHeaderImg:{
        width:'60px', 
        height:'60px',
        marginBottom:'30px',
    },
    tablePage: {
        width: '100%',
    },
    headerSpace: {
        height: '90px',
    },
    div: {
        fontSize: '10px'
    },
    h1: {
        /* marginLeft:'2cm',
        marginRight:'2cm', 
        marginTop: '50px',*/
        marginBottom: '30px',
        fontSize: '14px',
        fontWeight: '600',
    },
     h2: {
        fontSize: '12px',
        fontWeight: '600',
        /* marginLeft:'2cm',
        marginRight:'2cm', */
        marginTop: '15px',
        marginBottom: '25px',
    },
    h3: {
        fontSize: '9px',
        width: '100%',
        padding: '5px 10px',
        backgroundColor: '#92004D',
        color:'#fff',
        textTransform: 'uppercase',
        // border: '1px solid #e6e6e6',
        marginTop: '25px',
        marginBottom: '10px',
        fontWeight:'bold',
        /* marginLeft:'2cm',
        marginRight:'20cm', */
    },
    h4: {
        color: '#ab2a3e',
        marginBottom: '10px',
        marginTop: '20px',
        fontSize: '9px',
        fontWeight:'bold',
        /* marginLeft:'2cm',
        marginRight:'2cm', */
    },
    h5: {
        fontSize: '10px',
        marginTop: '4px',
        marginBottom: '4px',
        /* marginLeft:'2cm',
        marginRight:'2cm', */
    },
    h6: {
        fontSize: '9px',
        marginTop: '2px',
        marginBottom: '2px',
        /* marginLeft:'2cm',
        marginRight:'2cm', */
    },
    textBox: {
        border: '2px solid #e6e6e6',
        padding: '15px',
        marginTop: '15px',
    },
    tableRiesgos: {
        borderCollapse: 'collapse',
        width: '100%',
        tableLayout: 'fixed',
        marginBottom: '24px',
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        backgroundColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    simpleTableTh: {
        border: '1px solid #000000',
        padding: '5px',
        lineHeight: 1.1
    },
    simpleTableTd: {
        border: '1px solid #000000',
        padding: '5px',
        lineHeight: 1.1
    },
    tableRiesgosTd: {
        border: '1px solid #000000',
        padding: '5px',
        lineHeight: 1.1
    },
    tableRiesgosTh: {
        backgroundColor: '#375491',
        color: '#ffffff',
        fontSize: '12px',
        fontWeight: 'bold',
        border: '1px solid #000000',
        padding: '5px',
        lineHeight: 1.1
    },
    simpleTable: {
        borderCollapse: 'collapse',
        width: '80%',
        margin: '0 10% 24px 10%',
    },
    simpleTableTh: {
        textTransform: 'uppercase',
    },
    subul: {
        lineHeight: '1.8',
        fontSize:'8px',
        flexDirection: "column", 
        width: 400,
        marginLeft: '8px',
    },
    ul: {
        lineHeight: '1.8',
        fontSize:'7px',
        flexDirection: "column", 
        width: 400,
    },
    ol: {
        lineHeight: '1.8',
        flexDirection: "row", 
        marginBottom: 4,
        fontSize: '7px',
    },
    p: {
        lineHeight: '1.8',
        textAlign: 'justify',
        padding: '5px 10px',
        /* marginLeft:'2cm',
        marginRight:'2cm', */
        fontSize: '9px',
    },
    subp: {
        lineHeight: '1.8',
        textAlign: 'justify',
        marginLeft: '8px',
        fontSize: '8px',
    },
    br: {
        display: 'block',
        margin: '10px 0 2px 0',
        lineHeight: '5px',
        content: " ",
    },
    pageTitle: {
        textAlign: 'center',
        textDecoration: 'underline',
        fontWeight: 'bold',
        fontSize: '12px',
        marginBottom: '20px'
    },
    page: {
        size: 'A4 portrait',
        margin: '2cm',
    },
    pagebreak: {
        clear: 'both',
        pageBreakAfter: 'always',
    },
    textoNormal: {
        fontFamily: 'Roboto',
        fontWeight: 400
    },
    textoItalic: {
        fontFamily: 'Roboto',
        fontWeight: 400
    },
    textoNegritaItalic: {
        fontFamily: 'Roboto',
        fontWeight: 800
    },
    textoNegrita: {
        fontFamily: 'Roboto',
        fontWeight: 700
    },
    hr:{
        width: '90px',
        height: '3px',
        backgroundColor: '#92004D',
        borderColor: '#92004D',
        position: 'absolute',
        left: 250,
        right: 250,
        bottom: '90px',
        textAlign: 'center',
        margin: ' 0 auto',
        color: '#92004D',
    },
    pageHeader: {
        marginTop: 15, 
        paddingBottom: 15, 
        marginHorizontal: '1cm'
    },
    cuadrado:{
        border:1,
        marginTop:'20px',
        marginBottom:'20px'
    },
    lines: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    line: {
        flexDirection: 'row',
        // justifyContent: 'space-between',
        alignItems: 'center',
    },
    textoGirado: {
        transform: 'rotate(-90deg)',
        transformOrigin: 'center center',
      },
  });

const PlanEmergenciaRender = (props) => {
    const { t } = useTranslation('pdfs');

    const backgroundImageUrl = portada;
    const [isLoading, setIsLoading] = useState(true)
    const [errorCarga, setErrorCarga] = useState(false)
    const [proveedores, setProveedores] = useState([])
    const [hojaVisita, setHojaVisita] = useState({})
    const rows = Array.from({ length: 14 });
    const fetchData = async () => {
        // const response = await getFinca(props.params.nif)
        const sale = await getVisitSheetIdFromSale(props.params.id);
        // Venta inexistente, de baja o fuera del alcance del usuario: el endpoint responde 404
        // y el servicio devuelve undefined
        if (!sale?.detailsCae?.[0]) {
            setErrorCarga(true)
            setIsLoading(false)
            return
        }
        const visitSheet_id = sale.detailsCae[0].visitSheet_id;
        const respVisit = await getVisitSheet(visitSheet_id);
        if (!respVisit?.data) {
            setErrorCarga(true)
            setIsLoading(false)
            return
        }
        const { data } = respVisit
        let hojaVisita = data
        hojaVisita.imgURL = `${process.env.REACT_APP_STORAGE_URL}${data.img}`
        if (data.visitDate) {
            hojaVisita.fechaVisita = formatoFechasEs(data.visitDate)
            const renewDate = new Date(data.visitDate);
            hojaVisita.mesVisita = !isNaN(renewDate.getTime())
                ? format(renewDate, 'MMMM yyyy', {locale: getDateLocale()})
                : ''
        } else {
            hojaVisita.fechaVisita = ''
            hojaVisita.mesVisita = ''
        }
        let provs = data.propertie?.suppliers.filter( s => s.status === true )
        setHojaVisita(hojaVisita);
        setProveedores(provs)
        setIsLoading(false)
    }

    useEffect(() =>{
        fetchData();
    },[])

    return (
        <>
            {errorCarga ?
                <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'sans-serif', color: '#333' }}>
                    <p style={{ fontSize: '18px', fontWeight: 700, color: '#92004D' }}>{t('common.loadErrorTitle')}</p>
                    <p>{t('common.loadErrorText')}</p>
                </div>
            : isLoading ? <CircularProgress style={{color:'#92004D', position: 'absolute', top: '50%', left: '50%'}} /> :
                <PDFHandler style={{ width:"100%", height:"100vh"}}>
                    <Document size="A4" margin="2cm">
                        <Page>
                            <View>
                                <Image src={backgroundImageUrl} style={{ width: '100vw', height: '100vh' }}/>
                                <Text style={styles.docTitle}>
                                    {props.params.idCentroTrabajo
                                        ? hojaVisita.workcenter?.razonSocial
                                        : hojaVisita.propertie?.direccion
                                    }
                                </Text>
                                <Text style={styles.hr}></Text>
                                <Text style={styles.docTitle2}>
                                    {hojaVisita.mesVisita}
                                </Text>
                            </View>
                        </Page>
                        
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <View style={[styles.ul, {marginTop:'25px'}]}>
                                    <View style={styles.ol}>
                                        <Text style={[styles.h5, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.toc.introduction')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.h5, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.toc.emergencyMeasures')}</Text>
                                    </View>
                                    <View style={styles.ul}>
                                        <View style={[styles.ol, {paddingLeft: 20}]}>
                                            <Text style={[styles.h5, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.object')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 20}]}>
                                            <Text style={[styles.h5, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.protectionMeasures')}</Text>
                                        </View>
                                        <View style={styles.ul}>
                                            <View style={[styles.ol, {paddingLeft: 40}]}>
                                                <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.passive')}</Text>
                                            </View>
                                            <View style={[styles.ol, {paddingLeft: 40}]}>
                                                <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.active')}</Text>
                                            </View>
                                            <View style={styles.ul}>
                                                <View style={[styles.ol, {paddingLeft: 60}]}>
                                                    <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.detection')}</Text>
                                                </View>
                                                <View style={[styles.ol, {paddingLeft: 60}]}>
                                                    <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.alertSignaling')}</Text>
                                                </View>
                                                <View style={[styles.ol, {paddingLeft: 60}]}>
                                                    <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.extinguishingSystems')}</Text>
                                                </View>
                                                <View style={[styles.ol, {paddingLeft: 60}]}>
                                                    <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.portableExtinguishers')}</Text>
                                                </View>
                                                <View style={[styles.ol, {paddingLeft: 60}]}>
                                                    <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.fireHydrants')}</Text>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 20}]}>
                                            <Text style={[styles.h5, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.considerations')}</Text>
                                        </View>
                                        <View style={styles.ul}>
                                            <View style={[styles.ol, {paddingLeft: 40}]}>
                                                <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.commonAreas')}</Text>
                                            </View>
                                            <View style={[styles.ol, {paddingLeft: 40}]}>
                                                <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.elevator')}</Text>
                                            </View>
                                            <View style={[styles.ol, {paddingLeft: 40}]}>
                                                <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.meterRoom')}</Text>
                                            </View>
                                            <View style={[styles.ol, {paddingLeft: 40}]}>
                                                <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.storageRooms')}</Text>
                                            </View>
                                            <View style={[styles.ol, {paddingLeft: 40}]}>
                                                <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.garages')}</Text>
                                            </View>
                                            <View style={[styles.ol, {paddingLeft: 40}]}>
                                                <Text style={[styles.h6, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.commercialPremises')}</Text>
                                            </View>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 20}]}>
                                            <Text style={[styles.h5, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.prlCommonAreas')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 20}]}>
                                            <Text style={[styles.h5, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.proposals')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 20}]}>
                                            <Text style={[styles.h5, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.accidentRecommendations')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 20}]}>
                                            <Text style={[styles.h5, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.fireRecommendations')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 20}]}>
                                            <Text style={[styles.h5, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.utilityPhones')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 20}]}>
                                            <Text style={[styles.h5, styles.textoNegrita]} >{t('emergencyPlan.pdfContent.toc.annexI')}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                            <Text style={[styles.h2, styles.textoNegrita, {textAlign:'center', textDecoration:'underline'}]}>{t('emergencyPlan.pdfContent.introPage.title')}</Text>
                            </View>
                            <View>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.introPage.text1')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.introPage.text2')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.introPage.text3')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.introPage.text4')}</Text>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.introPage.text4a')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.introPage.text4b')}</Text>
                                    </View>
                                </View>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.introPage.text5')}</Text>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.introPage.text5a')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.introPage.text5b')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.introPage.text5c')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.introPage.text5d')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.introPage.text5e')}</Text>
                                    </View>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={[styles.h2, styles.textoNegrita, {textAlign:'center', textDecoration:'underline'}]}>{t('emergencyPlan.pdfContent.measuresPage.title')}</Text>
                            </View>
                            <View>
                                <Text style={[styles.h3, styles.textoNegrita, {textAlign:'center'}]}>{t('emergencyPlan.pdfContent.measuresPage.objectTitle')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.measuresPage.objectText')}</Text>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.measuresPage.objectItem1')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.measuresPage.objectItem2')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.measuresPage.objectItem3')}</Text>
                                    </View>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={[styles.h3, styles.textoNegrita, {textAlign:'center'}]}>{t('emergencyPlan.pdfContent.protectionPage.title')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.protectionPage.classificationIntro')}</Text>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline'}]}>{t('emergencyPlan.pdfContent.protectionPage.passiveTitle')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.protectionPage.passiveText')}</Text>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.protectionPage.passiveItem1')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.protectionPage.passiveItem2')}</Text>
                                    </View>
                                </View>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.protectionPage.passiveText2')}</Text>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.protectionPage.passiveItem3')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.protectionPage.passiveItem4')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.protectionPage.passiveItem5')}</Text>
                                    </View>
                                </View>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.protectionPage.passiveText3')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.protectionPage.sectorizationQuestion')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.protectionPage.sectorizationText')}</Text>
                                <View style={[styles.cuadrado, {marginBottom:0}]}>
                                    <Text style={[styles.p, {color:'#92004D', textAlign:'center', marginTop:10}]}>{t('emergencyPlan.pdfContent.protectionPage.recommendationsLabel')}</Text>
                                    <Text style={[styles.p, styles.textoItalic, {fontSize:7, color:'#555'}]}>{t('emergencyPlan.pdfContent.protectionPage.passiveRec1')}</Text>
                                    <Text style={[styles.p, styles.textoItalic, {fontSize:7, color:'#555'}]}>{t('emergencyPlan.pdfContent.protectionPage.passiveRec2')}</Text>
                                    <Text style={[styles.p, styles.textoItalic, {fontSize:7, color:'#555'}]}>{t('emergencyPlan.pdfContent.protectionPage.passiveRec3')}</Text>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline'}]}>{t('emergencyPlan.pdfContent.activeMeasures.title')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.activeMeasures.text')}</Text>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline'}]}>{t('emergencyPlan.pdfContent.activeMeasures.detectionTitle')}</Text>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.activeMeasures.detectionItem1')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.activeMeasures.detectionItem2')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.activeMeasures.detectionItem3')}</Text>
                                    </View>
                                </View>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.activeMeasures.alarmPushButtons')}</Text>
                                <View style={styles.cuadrado}>
                                    <Text style={[styles.p, {color:'#92004D', textAlign:'center', marginTop:10}]}>{t('emergencyPlan.pdfContent.protectionPage.recommendationsLabel')}</Text>
                                    <Text style={[styles.p, styles.textoItalic, {fontSize:7, color:'#555'}]}>{t('emergencyPlan.pdfContent.activeMeasures.detectionRec1')}</Text>
                                    <Text style={[styles.p, styles.textoItalic, {fontSize:7, color:'#555'}]}>{t('emergencyPlan.pdfContent.activeMeasures.detectionRec2')}</Text>
                                    <Text style={[styles.p, styles.textoItalic, {fontSize:7, color:'#555'}]}>{t('emergencyPlan.pdfContent.activeMeasures.detectionRec3')}</Text>
                                </View>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline', marginBottom: '10px', marginTop: '10px'}]}>{t('emergencyPlan.pdfContent.activeMeasures.alertTitle')}</Text>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9}]}>{t('emergencyPlan.pdfContent.activeMeasures.alertText')}</Text>
                                <View style={styles.cuadrado}>
                                    <Text style={[styles.p, {color:'#92004D', textAlign:'center', marginTop:10}]}>{t('emergencyPlan.pdfContent.protectionPage.recommendationsLabel')}</Text>
                                    <Text style={[styles.p, styles.textoItalic, {fontSize:7, color:'#555'}]}>{t('emergencyPlan.pdfContent.activeMeasures.alertRec1')}</Text>
                                    <Text style={[styles.p, styles.textoItalic, {fontSize:7, color:'#555'}]}>{t('emergencyPlan.pdfContent.activeMeasures.alertRec2')}</Text>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline'}]}>{t('emergencyPlan.pdfContent.extinguishingSystems.title')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.extinguishingSystems.text')}</Text>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline'}]}>{t('emergencyPlan.pdfContent.extinguishingSystems.portableTitle')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.extinguishingSystems.portableText')}</Text>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline'}]}>{t('emergencyPlan.pdfContent.extinguishingSystems.howToUseTitle')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.extinguishingSystems.howToUseText1')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.extinguishingSystems.howToUseText2')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.extinguishingSystems.howToUseText3')}</Text>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9}]}>{t('emergencyPlan.pdfContent.extinguishingSystems.handlingTitle')}</Text>
                                <Image src={extintores1} style={{ width: '100%', marginTop: 24 }} ></Image>
                                <View style={{display:'flex', position: 'relative', paddingLeft: 20}}>
                                    <Text style={[styles.p, {fontSize: 6, width: 100}]}>{t('emergencyPlan.pdfContent.extinguishingSystems.handlingStep1')}</Text>
                                    <Text style={[styles.p, {fontSize: 6, width: 100, position: 'absolute', top: 0, left: 180}]}>{t('emergencyPlan.pdfContent.extinguishingSystems.handlingStep2')}</Text>
                                    <Text style={[styles.p, {fontSize: 6, width: 100, position: 'absolute', top: 0, left: 350}]}>{t('emergencyPlan.pdfContent.extinguishingSystems.handlingStep3')}</Text>
                                </View>
                                <Image src={extintores2} style={{ width: '75%', marginTop: 24, marginBottom: 18 }} ></Image>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.extinguishingSystems.handlingText1')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.extinguishingSystems.handlingText2')}</Text>
                                <View style={[styles.cuadrado, {mmarginTop:10, marginBottom:10}]}>
                                    <Text style={[styles.p, {color:'#92004D'}]}>{t('emergencyPlan.pdfContent.extinguishingSystems.handlingWarning')}</Text>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline'}]}>{t('emergencyPlan.pdfContent.fireHydrants.title')}</Text>
                                <View style={{position:'relative'}}>
                                    <Text style={[styles.p, {width: 300}]}>{t('emergencyPlan.pdfContent.fireHydrants.text1')}</Text>
                                    <Text style={[styles.p, {width: 300}]}>{t('emergencyPlan.pdfContent.fireHydrants.text2')}</Text>
                                    <Image src={bocaIncendio} style={{ width: 150, position:'absolute', right:0, top:0 }} ></Image>
                                </View>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.fireHydrants.text3')}</Text>
                                <Text style={[styles.p, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.fireHydrants.howToUseTitle')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.fireHydrants.howToUseIntro')}</Text>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>1)</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.fireHydrants.step1')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>2)</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.fireHydrants.step2')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>3)</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.fireHydrants.step3')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 20}]}>
                                        <Text style={{ marginHorizontal: 8 }}>4)</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.fireHydrants.step4')}</Text>
                                    </View>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={[styles.h3, styles.textoNegrita, {textAlign:'center'}]}>{t('emergencyPlan.pdfContent.considerations.title')}</Text>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline'}]}>{t('emergencyPlan.pdfContent.considerations.commonAreasTitle')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.commonAreasText')}</Text>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.commonAreasItem1')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.commonAreasItem2')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.commonAreasItem3')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.commonAreasItem4')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.commonAreasItem5')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.commonAreasItem6')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.commonAreasItem7')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.commonAreasItem8')}</Text>
                                    </View>
                                </View>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline', marginTop:5}]}>{t('emergencyPlan.pdfContent.considerations.elevatorTitle')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.elevatorText')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.machineRoom')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.machineRoomText')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.machineRoomWarning')}</Text>
                                <View style={[styles.cuadrado, {marginTop:5, marginBottom:5}]}>
                                    <Text style={[styles.p, styles.textoItalic, {fontSize:7, color:'#555'}]}>{t('emergencyPlan.pdfContent.considerations.machineRoomRec')}</Text>
                                </View>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.elevatorPit')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.elevatorPitText')}</Text>
                                
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.cabin')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.cabinText')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.trappedInElevator')}</Text>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.trappedItem1')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.trappedItem2')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.trappedItem3')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.trappedItem4')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.trappedItem5')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.trappedItem6')}</Text>
                                    </View>
                                </View>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline', marginTop:5}]}>{t('emergencyPlan.pdfContent.considerations.meterRoomTitle')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.meterRoomText')}</Text>
                                <Image src={cuartoContadores} style={{ width: 180, textAlign:'center', marginHorizontal: 'auto', marginBottom:20, marginTop:20 }} ></Image>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.meterRoomItem1')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.meterRoomItem2')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.meterRoomItem3')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.meterRoomItem4')}</Text>
                                    </View>
                                </View>
                                
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline', marginTop:5}]}>{t('emergencyPlan.pdfContent.considerations.storageTitle')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.storageText')}</Text>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.storageItem1')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.storageItem2')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.storageItem3')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.storageItem4')}</Text>
                                    </View>
                                </View>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline', marginTop:5}]}>{t('emergencyPlan.pdfContent.considerations.garageTitle')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.garageText1')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.garageText2')}</Text>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.garageItem1')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.garageItem2')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.garageItem3')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.considerations.garageItem4')}</Text>
                                    </View>
                                </View>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline', marginTop:5}]}>{t('emergencyPlan.pdfContent.considerations.commercialTitle')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.commercialText')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.considerations.commercialRec')}</Text>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={[styles.h3, styles.textoNegrita, {textAlign:'center'}]}>{t('emergencyPlan.pdfContent.prlCommonAreas.title')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.prlCommonAreas.text')}</Text>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={[styles.h3, styles.textoNegrita, {textAlign:'center'}]}>{t('emergencyPlan.pdfContent.proposals.title')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.proposals.preventiveMeasures')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.proposals.programText')}</Text>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>a)</Text>
                                        <Text style={{ width:280, fontSize:9 }}>{t('emergencyPlan.pdfContent.proposals.itemA')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>b)</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.proposals.itemB')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>c)</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.proposals.itemC')}</Text>
                                    </View>
                                </View>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.proposals.investigationTitle')}</Text>
                                <Text style={styles.p}>{t('emergencyPlan.pdfContent.proposals.investigationText')}</Text>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <View style={[styles.h3, styles.lines]}>
                                    <Text style={[styles.textoNegrita, {textAlign:'center', display:'block'}]}>{t('emergencyPlan.pdfContent.accidentActions.title')}</Text>
                                    <Text style={[styles.p, {fontSize:8, textAlign:'center', display:'block'}]}>{t('emergencyPlan.pdfContent.accidentActions.subtitle')}</Text>
                                </View>
                                <View style={styles.ul}>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>a)</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.accidentActions.itemA')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>b)</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.accidentActions.itemB')}</Text>
                                    </View>
                                    <Text style={styles.p} >{t('emergencyPlan.accidentPlan.activatePAS')}</Text>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.pasItem1')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.pasItem2')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.pasItem3')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.pasItem4')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.pasItem5')}</Text>
                                    </View>
                                    <View style={[styles.ol, {paddingLeft: 10}]}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.pasItem6')}</Text>
                                    </View>
                                </View>
                                <View>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.accidentActions.eyeSplashTitle')}</Text>
                                    <Text style={styles.p}>{t('emergencyPlan.accidentPlan.firstAid.eyeSplash.text')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.accidentActions.dizzinessTitle')}</Text>
                                    <Text style={styles.p}>{t('emergencyPlan.accidentPlan.firstAid.dizziness.text')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.accidentActions.electrocutionTitle')}</Text>
                                    <Text style={styles.p}>{t('emergencyPlan.accidentPlan.firstAid.electrocution.text')}</Text>
                                    <View style={styles.ul}>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.firstAid.electrocution.item1')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.firstAid.electrocution.item2')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.firstAid.electrocution.item3')}</Text>
                                        </View>
                                    </View>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.accidentActions.burnsTitle')}</Text>
                                    <Text style={styles.p}>{t('emergencyPlan.accidentPlan.firstAid.burns.text')}</Text>
                                    <View style={styles.ul}>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.firstAid.burns.item1')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.firstAid.burns.item2')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.firstAid.burns.item3')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.firstAid.burns.item4')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.accidentPlan.firstAid.burns.item5')}</Text>
                                        </View>
                                    </View>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.accidentActions.poisoningTitle')}</Text>
                                    <Text style={styles.p}>{t('emergencyPlan.accidentPlan.firstAid.poisoning.text')}</Text>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={[styles.h3, styles.textoNegrita, {textAlign:'center', display:'block'}]}>{t('emergencyPlan.pdfContent.fireActions.title')}</Text>
                                <View>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.fireActions.evacuateTitle')}</Text>
                                    <View style={styles.ul}>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.fireActions.evacuateItem1')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.firePlan.evacuate.item2')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.firePlan.evacuate.item3')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.firePlan.evacuate.item4')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.firePlan.evacuate.item5')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.fireActions.evacuateItem6')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.firePlan.evacuate.item7')}</Text>
                                        </View>
                                    </View>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('emergencyPlan.firePlan.trapped.title')}</Text>
                                    <Text style={styles.p}>{t('emergencyPlan.firePlan.trapped.text1')}</Text>
                                    <Text style={styles.p}>{t('emergencyPlan.firePlan.trapped.text2')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('emergencyPlan.firePlan.personOnFire.title')}</Text>
                                    <Text style={styles.p}>{t('emergencyPlan.firePlan.personOnFire.text')}</Text>
                                    <View style={styles.ul}>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.firePlan.personOnFire.item1')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.firePlan.personOnFire.item2')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.firePlan.personOnFire.item3')}</Text>
                                        </View>
                                    </View>
                                    <Text style={styles.p}>{t('emergencyPlan.pdfContent.fireActions.personOnFireText2')}</Text>
                                    <View style={styles.ul}>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.fireActions.recItem1')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item2')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item3')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item4')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item5')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item7')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item8')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item9')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item10')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item11')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item12')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item13')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item14')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.recommendations.item15')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.fireActions.recItem17')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.fireActions.recItem19')}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={[styles.h3, styles.textoNegrita, {textAlign:'center', display:'block'}]}>{t('emergencyPlan.pdfContent.bibliography.title')}</Text>
                                <View>
                                    <View style={styles.ul}>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.bibliography.item1')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.bibliography.item2')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.bibliography.item3')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.bibliography.item4')}</Text>
                                        </View>
                                        <View style={[styles.ol, {paddingLeft: 10}]}>
                                            <Text style={{ marginHorizontal: 8 }}>•</Text>
                                            <Text style={{ fontSize:9 }}>{t('emergencyPlan.pdfContent.bibliography.item5')}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View>
                                <Text style={[styles.h3, styles.textoNegrita, {textAlign:'center', display:'block'}]}>{t('emergencyPlan.utilityPhones.title')}</Text>
                                <View style={styles.table}>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColHeaderSOS}>
                                            <Text style={styles.tableCell}></Text>
                                        </View>
                                        <View style={styles.tableColHeaderSOS}>
                                            <Text style={styles.tableCell}>{t('emergencyPlan.pdfContent.phonesPage.phoneHeader')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColSOS}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {fontSize:12}]}>{t('emergencyPlan.utilityPhones.emergencyCoordination')}</Text>
                                        </View>
                                        <View style={styles.tableColSOS}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {fontSize:12}]}>112 </Text>
                                        </View>
                                    </View>
                                </View>
                                <View>
                                    <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline', marginTop: 20}]}>{t('emergencyPlan.directory.title')}</Text></View>
                                    <Text style={[styles.p, styles.textoNegrita, {fontSize: 8}]}>{t('emergencyPlan.directory.workCenterLabel')}{
                                        props.params.idCentroTrabajo
                                            ? hojaVisita.workcenter?.razonSocial
                                            : hojaVisita.propertie?.direccion
                                    }</Text>
                                    <View style={styles.line}>
                                        <Text style={[styles.p, styles.textoNegrita, {fontSize: 8, marginRight: 150}]}>{t('emergencyPlan.pdfContent.phonesPage.contactPerson')}{hojaVisita.propertie?.nombreContacto}</Text>
                                        <Text style={[styles.p, styles.textoNegrita, {fontSize: 8}]}>{t('emergencyPlan.phone')}: {hojaVisita.propertie?.telefonoContacto}</Text>
                                    </View>
                                    <Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline', marginTop: 20}]}>{t('emergencyPlan.directory.maintenanceCompanies')}</Text>
                                    <View style={styles.table}>
                                        {proveedores?.length !== 0 ?
                                            <View style={styles.tableRow}>
                                                <View style={styles.tableColHeaderProv}>
                                                    <Text style={styles.tableCell}>{t('emergencyPlan.service')}</Text>
                                                </View>
                                                <View style={styles.tableColHeaderProv}>
                                                    <Text style={styles.tableCell}>{t('emergencyPlan.name')}</Text>
                                                </View>
                                                <View style={styles.tableColHeaderProv1}>
                                                    <Text style={styles.tableCell}>{t('emergencyPlan.pdfContent.phonesPage.phoneHeader')}</Text>
                                                </View>
                                            </View>
                                        :
                                            <View style={styles.tableRow}>
                                                <View style={styles.tableColHeaderNM}>
                                                    <Text style={styles.tableCell}>{t('emergencyPlan.pdfContent.phonesPage.noSuppliers')}</Text>
                                                </View>
                                            </View>
                                        }                                             
                                            
                                        {proveedores?.length !== 0 ?
                                            proveedores?.map((proveedor, i) => {
                                                return (
                                                    <View key={i} style={styles.tableRow}> 
                                                        <View style={styles.tableCol}> 
                                                            <Text style={styles.tableCell}>{proveedor?.serviceSupps?.find( serv => serv.id === proveedor?.r_propSupp?.service) !== undefined ? proveedor?.serviceSupps?.find( serv => serv.id === proveedor?.r_propSupp?.service).nombre : null}</Text> 
                                                        </View>
                                                        <View style={styles.tableCol}> 
                                                            <Text style={styles.tableCell}>{proveedor.razonSocial}</Text> 
                                                        </View>
                                                        <View style={styles.tableCol1}> 
                                                            <Text style={styles.tableCell}>{proveedor.telefonoContacto}</Text> 
                                                        </View>
                                                    </View>
                                                )
                                            })
                                        : 
                                            <></>
                                        }
                                            
                                    </View>
                                    <View ><Text style={[styles.p, styles.textoNegrita, {fontSize: 9, textDecoration:'underline', marginTop: 20}]}>{t('emergencyPlan.pdfContent.phonesPage.associatedTechnicianTitle')}</Text></View>
                                    <Text style={styles.p}>
                                        {t('emergencyPlan.associatedTechnician.text')}<Text style={styles.bold}>{hojaVisita.technician?.nombre} {hojaVisita.technician?.apellidos}</Text>{t('emergencyPlan.associatedTechnician.role')}
                                    </Text>
                            </View>
                        </Page>
                        <Page style={styles.body} orientation="landscape">
                            <View style={styles.pageHeader} fixed>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Image src={LogoLAE} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    <Image src={LogoTSP} style={{ marginTop: 10, width: '14%', paddingRight: 5 }} />
                                </View>
                            </View>
                            <View style={[styles.h3, styles.lines]}>
                                <Text style={[styles.textoNegrita, {textAlign:'center', display:'block'}]}>{t('emergencyPlan.pdfContent.annexPage.title')}</Text>
                                <Text style={[styles.p, {fontSize:8, textAlign:'center', display:'block'}]}>{t('emergencyPlan.pdfContent.annexPage.subtitle')}</Text>
                            </View>
                            <View style={styles.line}>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 8, marginRight: 150}]}>{t('emergencyPlan.pdfContent.annexPage.dateLabel')}</Text>
                                <Text style={[styles.p, styles.textoNegrita, {fontSize: 8}]}>{t('emergencyPlan.pdfContent.annexPage.doneByLabel')}</Text>
                            </View>
                            <View style={styles.table}> 
                                    <View style={styles.tableRow}> 
                                        <View style={[styles.tableColHeaderExt, {width:'3.09%', position:'relative'}]}>
                                            <Text style={[styles.tableCellExt, styles.textoNegrita, styles.textoGirado, {position:'absolute', margin:0, bottom:15, height:25, width:40}]}>{t('emergencyPlan.pdfContent.annexPage.extinguisherNo')}</Text>
                                        </View>
                                        <View style={[styles.tableColHeaderExt, {width:'12.09%'}]}>
                                            <View style={styles.lines}>
                                                <Text style={[styles.tableCellExt, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.annexPage.type')}</Text>
                                                <Text style={{fontSize:7}}>{t('emergencyPlan.pdfContent.annexPage.typeExample')}</Text>
                                            </View>
                                        </View>
                                        <View style={[styles.tableColHeaderExt, {width:'12.09%', margin: 0, padding:0}]}>
                                            <View style={styles.lines}>
                                                <Text style={[styles.tableCellExt, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.annexPage.location')}</Text>
                                                <Text style={{fontSize:7, margin: 0, padding:0}}>{t('emergencyPlan.pdfContent.annexPage.locationExample')}</Text>
                                            </View>
                                        </View>
                                        <View style={[styles.tableColHeaderExt, {width:'4.09%'}]}>
                                            <Text style={[styles.tableCellExt, styles.textoNegrita, styles.textoGirado, {position:'absolute', margin:0, bottom:15, height:25, width:50}]}>{t('emergencyPlan.pdfContent.annexPage.signaling')}</Text>
                                        </View>
                                        <View style={[styles.tableColHeaderExt, {width:'4.09%'}]}>
                                            <Text style={[styles.tableCellExt, styles.textoNegrita, styles.textoGirado, {position:'absolute', margin:0, bottom:15, height:25, width:50}]}>{t('emergencyPlan.pdfContent.annexPage.accessibility')}</Text>
                                        </View>
                                        <View style={styles.tableColHeaderExt}>
                                            <View style={[styles.lines, styles.tableCellExt]}>
                                                <Text style={[styles.textoNegrita, {fontSize:8}]}>{t('emergencyPlan.pdfContent.annexPage.apparentState')}</Text>
                                                <Text style={[styles.textoNegrita, {fontSize:8}]}>{t('emergencyPlan.pdfContent.annexPage.apparentStateOf')}</Text>
                                            </View>
                                        </View>
                                        <View style={[styles.tableColHeaderExt, {width:'6.09%'}]}>
                                            <View style={styles.lines}>
                                                <Text style={[styles.tableCellExt, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.annexPage.sealPin')}</Text>
                                                <Text style={[styles.textoNegrita, {fontSize:8}]}>{t('emergencyPlan.pdfContent.annexPage.pin')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableColHeaderExt}>
                                            <View style={styles.lines}>
                                                <Text style={[styles.tableCellExt, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.annexPage.pressure')}</Text>
                                                <Text style={{fontSize:7}}>{t('emergencyPlan.pdfContent.annexPage.pressureNote')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableColHeaderExt}>
                                            <View style={styles.lines}>
                                                <Text style={[styles.tableCellExt, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.annexPage.nozzle')}</Text>
                                                <Text style={[styles.textoNegrita, {fontSize:8}]}>{t('emergencyPlan.pdfContent.annexPage.valve')}</Text>
                                            </View>
                                        </View>
                                        <View style={[styles.tableColHeaderExt, {width:'3.09%'}]}>
                                            <Text style={[styles.tableCellExt, styles.textoNegrita, styles.textoGirado, {position:'absolute', bottom:15}]}>{t('emergencyPlan.pdfContent.annexPage.box')}</Text>
                                        </View>
                                        <View style={[styles.tableColHeaderExt1, {width:'28.01%', display:'flex', alignItems:'center'}]}>
                                            <Text style={[styles.tableCellExt, styles.textoNegrita]}>{t('emergencyPlan.pdfContent.annexPage.observations')}</Text>
                                        </View>
                                    </View>
                                    {rows.map((_, index) => (
                                        <View key={index} style={styles.tableRow}> 
                                            <View style={[styles.tableColExt, {width:'3.09%'}]}> 
                                                <Text style={[styles.tableCell, styles.textoNegrita]}></Text> 
                                            </View> 
                                            <View style={[styles.tableColExt, {width:'12.09%'}]}> 
                                                <Text style={[styles.tableCell, styles.textoNegrita]}></Text> 
                                            </View>    
                                            <View style={[styles.tableColExt, {width:'12.09%'}]}> 
                                                <Text style={[styles.tableCell, styles.textoNegrita]}></Text> 
                                            </View> 
                                            <View style={[styles.tableColExt, {width:'4.09%'}]}> 
                                                <Text style={[styles.tableCell, styles.textoNegrita]}></Text> 
                                            </View>    
                                            <View style={[styles.tableColExt, {width:'4.09%'}]}> 
                                                <Text style={[styles.tableCell, styles.textoNegrita]}></Text> 
                                            </View> 
                                            <View style={styles.tableColExt}> 
                                                <Text style={[styles.tableCell, styles.textoNegrita]}></Text> 
                                            </View>    
                                            <View style={[styles.tableColExt, {width:'6.09%'}]}> 
                                                <Text style={[styles.tableCell, styles.textoNegrita]}></Text> 
                                            </View> 
                                            <View style={styles.tableColExt}> 
                                                <Text style={[styles.tableCell, styles.textoNegrita]}></Text> 
                                            </View>    
                                            <View style={styles.tableColExt}> 
                                                <Text style={[styles.tableCell, styles.textoNegrita]}></Text> 
                                            </View> 
                                            <View style={[styles.tableColExt, {width:'3.09%'}]}> 
                                                <Text style={[styles.tableCell, styles.textoNegrita]}></Text> 
                                            </View>
                                            <View style={[styles.tableColExt, {width:'28.01%'}]}> 
                                                <Text style={[styles.tableCell, styles.textoNegrita]}></Text> 
                                            </View> 
                                        </View> 
                                    ))}
                                </View>
                            <Image src={estado} style={{width:100}} ></Image>
                        </Page>
                    </Document>
                </PDFHandler>
            }
        </>
        
    )
}
 
export default withRouter(PlanEmergenciaRender);